module.exports = "<div class=\"cp-spinner cp-balls {{size}}\" [ngStyle]=\"{display: loading ? 'block' : 'none'}\"></div>\n"